var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"kf",on:{"mouseenter":function($event){return _vm.enterContent(1)},"mouseleave":function($event){return _vm.enterContent(2)},"click":_vm.gotoKf}},[_c('span',{staticClass:"uhi-icon-kefu iconfont",style:(_vm.iconColor)})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }